import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AdminDataCreateDto } from '../dtos/admindata/adminDataCreateDto';
import { AdminDataUpdateDto } from '../dtos/admindata/adminDataUpdateDto';

@Injectable({
  providedIn: 'root'
})
export class VisaStatusService {
  private apiUrl = `${environment.apiUrl}/visaStatus`; // API URL'yi güncelliyoruz

  constructor(private http: HttpClient) {}

  // GET: Tüm Visa Status verilerini al
  getAll(): Observable<any> {
    return this.http.get<any>(this.apiUrl);
  }

  // GET: Visa Status ID'ye göre veriyi al
  getById(id: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/${id}`);
  }

  // POST: Yeni bir Visa Status ekle
  create(visaStatus: AdminDataCreateDto): Observable<any> {
    return this.http.post(this.apiUrl, visaStatus); 
  }

  // PUT: Mevcut Visa Status'u güncelle
  update(visaStatus: AdminDataUpdateDto): Observable<any> {
    return this.http.put(`${this.apiUrl}/${visaStatus.id}`, visaStatus);
  }

  // DELETE: Visa Status'u sil
  delete(id: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${id}`);
  }
}
